'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const CaseManagementIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="CaseManagementIcon">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke={sx?.color ? sx.color : '#273443'}
      >
        <path d="M0.5 6H23.5V22H0.5V6Z" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M8.5 6V4C8.50158 3.47005 8.7128 2.96227 9.08753 2.58753C9.46227 2.2128 9.97005 2.00158 10.5 2H13.5C14.0299 2.00158 14.5377 2.2128 14.9125 2.58753C15.2872 2.96227 15.4984 3.47005 15.5 4V6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M19.5 6V22" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16.5 6V22" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.5 6V22" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.5 6V22" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </SvgIcon>
  )
}

CaseManagementIcon.propTypes = {
  sx: PropTypes.object
}
